import React, { useEffect, useRef, useState, useContext } from 'react';
import styled from 'styled-components';
import useMessages from '../../../hooks/chat/useMessages';
import { useChat } from '../../../context/provider/ChatProvider';
import { Fetch } from '../../../services/api';
import { notify } from '../../../utils/utils';
import { UserContext } from '../../../context/provider/UserProvider';

const ConversationContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1vh;
    flex: 1;
    padding: 20px 0;
    overflow: auto;
    max-height:300px;
`;

const Conversation = () => {
    const { socket, setMessageToReply } = useChat();
    const messages = useMessages();
    const chatConversation = useRef(null);
    const [ mensajes, setMensajes ] = useState()
    const { stateUser, signOut } = useContext(UserContext)


    useEffect(() => {
        chatConversation.current.scrollTo(0, chatConversation.current.scrollHeight);    
    }, [messages]);

    const formatTime = (timestamp) => {
        const date = new Date(timestamp);
    
        // Obtener día, mes y año
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Los meses van de 0 a 11, por eso se suma 1
        const year = date.getFullYear();
    
        // Obtener horas, minutos y segundos
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }

    const buscarMensajeRepondido = (idMensaje) => {
        if (!idMensaje) return
        
        const targetElement = document.getElementById(`msg-${idMensaje}`)
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
            targetElement.classList.add('bg-white/10', 'transition-colors', 'duration-300', 'rounded') //efecto para saber el mensaje encontrado
            setTimeout(() => {
                targetElement.classList.remove('bg-white/10', 'transition-colors', 'duration-300', 'rounded')
            }, 800)
        } else {
            notify("El mensaje original no se encuentra cargado en el historial.", "warning")
        }
    }

    return (
        <ConversationContainer className="containerScroll min-h-[80%]" ref={ chatConversation }>
            {
                messages.map((m,i) => {
                    const { content, owner, socket_id, id, createdAt, _id } = m;
                    const isBot = (owner.nickname === 'BOT' && ! socket_id);
                    const miMensaje = owner.nickname !== stateUser.uid
                    return isBot ?
                        <div key={i++} className='w-full text-xs text-center '> { content } </div>
                    :
                    (
                        <div 
                            key={ i++ }
                            id={`msg-${_id}`}
                            className={` 
                                flex gap-2 text-lg group items-center
                                ${miMensaje? ' flex-row ' : ' flex-row-reverse '}
                            `}

                        >
                            <img 
                                src={
                                    miMensaje?
                                        'https://d1nhio0ox7pgb.cloudfront.net/_img/g_collection_png/standard/512x512/user.png' 
                                    :
                                        'https://manager.beexqr.com/static/media/icon_beexqr.fw.61fbb225a80f62ba741e.png' 
                                    }
                                className='flex h-6 w-6 rounded-full self-end mb-2'
                                alt=''
                            />
                            <div className="flex flex-col relative max-w-[50%]">
                                <button
                                    onClick={() => setMessageToReply(m)}
                                    className={`hidden group-hover:flex absolute top-1/2 -translate-y-1/2 bg-zinc-700 text-white p-2 rounded-full shadow cursor-pointer hover:bg-zinc-600 z-10 transition-all ${miMensaje ? '-right-10' : '-left-10'}`}
                                    title="Responder a este mensaje"
                                >
                                    <i className="fa-solid fa-reply text-xs"></i>
                                </button>
                                <div
                                    className={` 
                                        flex flex-col gap-1 text-lg border 
                                        text-black mt-2
                                        rounded-b-xl px-2 py-2 min-w-[150px] shadow-sm
                                        ${miMensaje ? 'bg-amber-100 rounded-r-xl border-amber-200' : 'bg-lime-100 rounded-l-xl border-lime-200'}
                                    `}
                                >  
                                    {m.replyTo && (
                                        <div 
                                            onClick={() => buscarMensajeRepondido(m.replyTo._id)}
                                            className="bg-black/10 border-l-4 border-zinc-500 p-1 mb-1 rounded flex flex-col gap-1 cursor-pointer hover:bg-black/20 transition-colors"
                                        >
                                            <span className="font-bold text-zinc-700 block text-[11px]">{m.replyTo.nickname}</span>
                                            { (!m.replyTo.messageType || m.replyTo.messageType === 'text') ? (
                                                <span className="text-zinc-800 italic text-xs truncate max-w-[200px]">
                                                    {m.replyTo.content}
                                                </span>
                                            ) : m.replyTo.messageType === 'image' ? (
                                                <div className="flex items-center gap-1 text-xs italic text-zinc-800">
                                                    <i className="fa-solid fa-image"></i> Foto
                                                </div>
                                            ) : m.replyTo.messageType === 'video' ? (
                                                <div className="flex items-center gap-1 text-xs italic text-zinc-800">
                                                    <i className="fa-solid fa-video"></i> Video
                                                </div>
                                            ) : (
                                                <div className="flex items-center gap-1 text-xs italic text-zinc-800">
                                                    <i className="fa-solid fa-file-lines"></i> Documento
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    <span 
                                        className={` 
                                            text-[13px] font-bold
                                            ${miMensaje ? ' text-red-500 ' : 'text-blue-500 '}
                                        `}
                                    >
                                        {owner.nickname}
                                    </span>  

                                    <div className="text-sm font-light grid py-1">
                                        {content}
                                        {
                                            (!m.messageType || m.messageType === "text")
                                            ? ''
                                            :
                                                (
                                                    m.messageType === "image"
                                                    ?
                                                        <img
                                                            src={m.media.url}
                                                            alt={m.media.original}
                                                            className="w-44 rounded cursor-pointer"
                                                            onClick={() => window.open(m.media.url,"_blank")}
                                                        />
                                                    :
                                                        <span
                                                            className="text-5xl cursor-pointer"
                                                            onClick={() => window.open(m.media.url,"_blank")}
                                                        >{ m.messageType === "video" ? "🎞️" : "📄"}</span>
                                                )
                                        }
                                    </div>
                                    <span className={`text-xs text-right px-2 justify-end text-gray-500`} >
                                        {formatTime(createdAt).split(" ")[1]}
                                    </span>  
                                </div>
                            </div>
                        </div>
                        
                    );
                })
            }
        </ConversationContainer>
    );
};

export default Conversation;